import * as React from 'react'

import { Section } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import DiscoverabilityForm from 'modules/settings/lib/forms/DiscoverabilityWidget'

const DiscoverabilityWidgetSettings = () => {
  const discoverabilityForm = React.useRef(
    new DiscoverabilityForm({
      hints: users.current.attributes.discoverability_widget_value,
    })
  ).current

  const options = [
    { label: i18n.t('personal_settings.discoverability_widget.true'), value: true },
    { label: i18n.t('personal_settings.discoverability_widget.false'), value: false },
  ]

  const onSubmit = async () => {
    const value = discoverabilityForm.get('hints').value
    const { success } = await asyncAction(() =>
      users.current.rpc('change_discoverability_widget', {
        hints: value,
      })
    )

    if (success) {
      discoverabilityForm.cleanAll()
      users.current.attributes.discoverability_widget_value = value
    }
  }

  return (
    <Section.Form
      illustration="window-star"
      title={i18n.t('personal_settings.discoverability_widget.title')}
      description={i18n.t('personal_settings.discoverability_widget.description')}
      onSubmit={onSubmit}
      submitLabel={i18n.t('common.submit')}
      isDirty={discoverabilityForm.isDirty}
    >
      <Select
        label={i18n.t('personal_settings.discoverability_widget.title')}
        options={options}
        field={discoverabilityForm.get('hints')}
      />
    </Section.Form>
  )
}

export default observer(DiscoverabilityWidgetSettings)
